import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=a2ae369a&"
import script from "./bargain.vue?vue&type=script&lang=js&"
export * from "./bargain.vue?vue&type=script&lang=js&"
import style0 from "./bargain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports